/**
 * Order history for the signed-in customer — TanStack Query over the shared
 * apiClient. Hits GET /api/v1/users/me/orders (clerk-authed — callers must be
 * inside AuthGuard so the apiClient token getter is wired up). Returns orders
 * newest first, each with snapshot line items.
 *
 * Design: docs/technical-design-website-product.md §4.3
 */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/services/api-client';
import type { MyOrder } from '@/types';

export const MY_ORDERS_QUERY_KEY = ['users', 'me', 'orders'] as const;

export function useMyOrders() {
  return useQuery({
    queryKey: MY_ORDERS_QUERY_KEY,
    queryFn: async () => {
      const response = await apiClient.get<MyOrder[]>('/api/v1/users/me/orders');
      if (!response.success || !response.data) {
        throw new Error(response.error?.message || 'Failed to load your orders');
      }
      return response.data;
    },
  });
}
